import { Box } from '@mui/material'
import React from 'react'
import { StyledHeader } from '../styles'

import GenericButton from '../../../components/GenericButton'
import { ButtonSize, ButtonType } from '../../../components/GenericButton/styles'
import { useNavigate } from 'react-router-dom'
import ROUTES from '../../../consts/paths'
import theme from '../../../theme'

interface CreateSurveyTemplatePageProps {
  setIsWizardOpen: (isOpen: boolean) => void
}

export const CreateSurveyTemplatePage: React.FC<CreateSurveyTemplatePageProps> = ({ setIsWizardOpen }): JSX.Element => {
  const navigate = useNavigate()
  return (
    <Box
      flexGrow='1'
      display='flex'
      flexDirection='column'
      alignItems='center'
      justifyContent='center'
    >
      <StyledHeader pl={theme.spacing(30)} pr={theme.spacing(30)}>
        You will be redirected to a new window to create a survey template. Once you have finished, please return here to continue to the next step.
      </StyledHeader>
      <GenericButton
        variant='contained'
        label='Navigate to Survey Templates'
        buttonSize={ButtonSize.Large}
        buttonType={ButtonType.Primary}
        onClick={() => {
          setIsWizardOpen(false)
          navigate(ROUTES.SURVEYS)
        }}
      />
    </Box>
  )
}
